/**
 * Application Routes Configuration
 * Defines all routes and their components
 */

import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import LoadingSpinner from '../shared/components/LoadingSpinner';
import { ROUTES } from '../shared/constants/routes';
import Login from '../components/Login';

// Lazy load pages for code splitting
const Dashboard = lazy(() => import('../features/dashboard/components/Dashboard'));
const Devices = lazy(() => import('../features/devices/components/Devices'));
const MapView = lazy(() => import('../features/map/components/MapView'));
const Analytics = lazy(() => import('../features/analytics/components/Analytics'));
const Queries = lazy(() => import('../features/queries/components/Queries'));
const InfluxDBView = lazy(() => import('../features/influxdb/components/InfluxDBView'));
const DynamoDBView = lazy(() => import('../features/dynamodb/components/DynamoDBView'));
const ExcelView = lazy(() => import('../features/excel/components/ExcelView'));
const Users = lazy(() => import('../features/users/components/Users'));
const Settings = lazy(() => import('../features/settings/components/Settings'));

// Loading component
const LoadingFallback = () => <LoadingSpinner message="Loading page..." fullScreen />;

function AppRoutes() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Public Routes */}
        <Route path={ROUTES.LOGIN} element={<Login />} />

        {/* Protected Routes */}
        <Route
          path={ROUTES.DASHBOARD}
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.DEVICES}
          element={
            <PrivateRoute>
              <Devices />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.MAP}
          element={
            <PrivateRoute>
              <MapView />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.ANALYTICS}
          element={
            <PrivateRoute>
              <Analytics />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.QUERIES}
          element={
            <PrivateRoute>
              <Queries />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.INFLUXDB}
          element={
            <PrivateRoute>
              <InfluxDBView />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.DYNAMODB}
          element={
            <PrivateRoute>
              <DynamoDBView />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.EXCEL}
          element={
            <PrivateRoute>
              <ExcelView />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.USERS}
          element={
            <PrivateRoute>
              <Users />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.SETTINGS}
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />

        {/* Default redirect */}
        <Route path={ROUTES.HOME} element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        <Route path="*" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;

